<template>
  <div v-if="usps.length" class="top-badges">
    <span
      v-for="(usp, i) in usps"
      :key="i"
      class="usp-badge"
      :class="`usp-badge--${getUspType(usp.type)}`"
      :style="{
        backgroundColor: `${usp.color || '#696969'}1A`,
        borderColor: usp.color || '#696969',
        color: usp.color || '#696969',
      }"
    >
      {{ usp.text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'UspBadges',

  props: {
    /**
     * @type {Array}
     */
    usps: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    /**
     * @param {string} type
     * @returns {string|string}
     */
    getUspType(type) {
      return type ? type.toLowerCase() : ''
    },
  },
}
</script>
